import React from 'react'
import img2023 from '../components/images/flipkartspn.jpg'

const events = () => {
    return (

        <>
            <div className='container'>
                <div className="row  m-2">
                    <img src={img2023} alt='flipkartspn' />
                </div>
                <div className="row m-2">
                    <div className="col-sm ">

                        <h2 className='p-2'>Streamline Your Success with E Seller Support, Your Trusted Flipkart SPN Partner
                        </h2>
                        <p>As a trusted Flipkart SPN partner, E Seller Support offers you unparalleled expertise and support in navigating the Flipkart marketplace. Our comprehensive range of services, including account management, product listings, and compliance support, ensures your business thrives on one of India’s leading e-commerce platforms. With our deep understanding of Flipkart’s ecosystem and our proven strategies, we empower you to maximize your business potential seamlessly and effectively. Trust E Seller Support to deliver the expertise and results you need to excel in the competitive e-commerce landscape of India. </p>
                    </div>
                    <div className="col-sm ">
                        {/* <img src={img201} alt='Queryimg' /> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default events